/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class KubernetesClusterPrometheusDetails {
    getFixupPrototypeFunction() { return KubernetesClusterPrometheusDetails.fixupPrototype; }

    static newInstance(model: Partial<KubernetesClusterPrometheusDetails>): KubernetesClusterPrometheusDetails {
        let obj = Object.assign(new KubernetesClusterPrometheusDetails(), model);
        KubernetesClusterPrometheusDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<KubernetesClusterPrometheusDetails>): KubernetesClusterPrometheusDetails {
        if (!model) return null;
        return KubernetesClusterPrometheusDetails.newInstance(<KubernetesClusterPrometheusDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: KubernetesClusterPrometheusDetails) {
        if (!obj) return;

        models.KubernetesClusterPrometheusDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: KubernetesClusterPrometheusDetails): boolean {
        Object.setPrototypeOf(obj, KubernetesClusterPrometheusDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Prometheus URL
     */
    prometheus_url: string;

    /**
     * Certificate Path
     */
    certificate_path: string;

}
